export const GROUP_DROPPABLE_TYPE = "ACTION_ITEM_GROUP";
export const ITEM_DROPPABLE_TYPE = "ACTION_ITEM";
export const INITIAL_ITEMS_TO_RENDER = 10;
export const ADDITIONAL_ITEMS_TO_RENDER_ON_EXPANSION = 50;

// Store
export const ACTION_ITEMS_STORE = "actionItems";
const ACTION_ITEMS_STORE_PREFIX = `${ACTION_ITEMS_STORE}.`;
export const ACTION_ITEMS_TEAMMATES_SUFFIX = "-teammates";
export const ACTION_ITEMS_STREAM_SUFFIX = "-stream";
export const ACTION_ITEMS_PANEL_SUFFIX = "-panel";
export const ACTION_ITEMS_STORE_GROUP_BY = `${ACTION_ITEMS_STORE_PREFIX}groupBy`;
export const ACTION_ITEMS_STORE_SORT_BY = `${ACTION_ITEMS_STORE_PREFIX}sortBy`;
export const ACTION_ITEMS_STORE_SHOW_COMPLETED = `${ACTION_ITEMS_STORE_PREFIX}showCompleted`;
export const ACTION_ITEMS_STORE_SHOW_WONT_DO = `${ACTION_ITEMS_STORE_PREFIX}showWontDo`;
export const ACTION_ITEMS_STORE_SHOW_AI_DETECTED = `${ACTION_ITEMS_STORE_PREFIX}showAIDetected`;
export const ACTION_ITEMS_STORE_SHOW_CREATED_BY_YOU = `${ACTION_ITEMS_STORE_PREFIX}showCreatedByYou`;
export const ACTION_ITEMS_STORE_SHOW_RECENT_ONLY = `${ACTION_ITEMS_STORE_PREFIX}showRecentOnly`;
export const ACTION_ITEMS_STORE_HIDE_AI = `${ACTION_ITEMS_STORE_PREFIX}hideAI`;

// Group By
export const GROUP_BY_CUSTOM = "CUSTOM";
export const GROUP_BY_DUE_DATE = "DUE_DATE";
export const GROUP_BY_STREAM = "STREAM";
export const GROUP_BY_ASSIGNEE = "ASSIGNEE";
export const GROUP_BY_NONE = "NONE";

// Sort
export const SORT_BY_CUSTOM = "CUSTOM";
export const SORT_BY_DUE_DATE = "DUE_DATE";
export const SORT_BY_DATE_CREATED = "DATE_CREATED";

// Synthetic groups
export const NO_DUE_DATE = "NO_DUE_DATE";
export const OVERDUE = "OVERDUE";
export const TODAY = "TODAY";
export const NO_STREAMS = "NO_STREAMS";

// Actions views
export const DUE_DATE_VIEW = "dueDate";
export const REASSIGN_VIEW = "reassign";

// Views
export enum Views {
	USER = "USER",
	TEAMMATES = "TEAMMATES",
	STREAM_TAB = "STREAM_TAB",
	RECORDING = "RECORDING",
}
